// src/components/battle/BattleDetailInfoCard.jsx

import React from "react";

export default function BattleDetailInfoCard({
  battleId,
  battleName,
  courseName,
  ownerName,
  modeLabel,
  statusLabel,
  genderLabel,
  startDatetimeText,
  endDatetimeText,
  joinCountText,
  myStatusLabel,
}) {
  // 상태 뱃지 색상 (라벨 기준, 로직 X)
  const statusStyle = (() => {
    if (statusLabel?.includes("모집중")) {
      return "bg-[rgb(0,224,198)]/10 text-[rgb(0,224,198)]";
    }
    if (statusLabel?.includes("모집완료")) {
      return "bg-amber-100 text-amber-700";
    }
    if (statusLabel?.includes("종료")) {
      return "bg-gray-200 text-gray-600";
    }
    return "bg-gray-100 text-gray-600";
  })();

  return (
    <section className="bg-white/90 rounded-3xl shadow-md px-5 py-4 space-y-4 border border-gray-100">
      {/* 상단 타이틀 + 상태 */}
      <header className="flex items-start justify-between gap-3">
        <div className="space-y-1">
          <h1 className="text-base font-bold text-gray-900 break-words">
            {battleName}
          </h1>
          <p className="text-xs text-gray-500 space-x-1">
            <span className="font-medium text-gray-700">
              코스명&nbsp;|&nbsp;
            </span>
            <span>{courseName}</span>
            <span className="mx-1 text-gray-300">·</span>
            <span className="font-medium text-gray-700">
              생성자&nbsp;|&nbsp;
            </span>
            <span>{ownerName}</span>
          </p>
        </div>

        <div className="flex flex-col items-end gap-1">
          <span
            className={`px-3 py-1 rounded-full text-[11px] font-semibold ${statusStyle}`}
          >
            {statusLabel || "-"}
          </span>
         
        </div>
      </header>

      {/* 모드 / 성별 / 내 상태 칩 */}
      <div className="flex flex-wrap gap-2 text-[11px]">
        <span className="px-3 py-1 rounded-full bg-[rgb(0,224,198)]/10 text-[rgb(0,224,198)] font-semibold">
          {modeLabel}
        </span>
        <span className="px-3 py-1 rounded-full bg-indigo-50 text-indigo-500 font-semibold">
          {genderLabel}
        </span>
        <span className="px-3 py-1 rounded-full bg-gray-50 text-gray-600">
          내 상태&nbsp;·&nbsp;
          <span className="font-semibold">{myStatusLabel}</span>
        </span>
      </div>

      {/* 정보 그리드 (날짜/인원) */}
      <div className="grid grid-cols-2 gap-3 text-xs">
        <div className="space-y-1">
          <p className="text-[11px] font-semibold text-gray-500">
            시작 일시
          </p>
          <p className="text-sm font-medium text-gray-900">
            {startDatetimeText || "-"}
          </p>
        </div>

        <div className="space-y-1 text-right">
          <p className="text-[11px] font-semibold text-gray-500">
            종료 일시
          </p>
          <p className="text-sm font-medium text-gray-900">
            {endDatetimeText || "-"}
          </p>
        </div>

        <div className="space-y-1">
          <p className="text-[11px] font-semibold text-gray-500">대결 인원</p>
          <p className="text-sm font-semibold text-gray-900">
            {joinCountText || "-"}
          </p>
        </div>

       
      </div>
    </section>
  );
}
